import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-store-kpi',
  templateUrl: './store-kpi.component.html',
  styleUrls: ['./store-kpi.component.css']
})
export class StoreKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi8: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  StoreKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi8: boolean = false;
  manfMonthFilterKpi8: monthFilter;

  Highcharts = Highcharts;

  totalDataMATD: any;
  totalDataKpiChartOptionsMATD: Highcharts.Options;
  panelWiseDataMATD: any;
  panelWiseKpiChartOptionsMATD: Highcharts.Options;

  totalDataMATL: any;
  totalDataKpiChartOptionsMATL: Highcharts.Options;
  panelWiseDataMATL: any;
  panelWiseKpiChartOptionsMATL: Highcharts.Options;

  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-9', this.isManfMonthFilterSelectedKpi8 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi8) {
      this._dataService.setCookie('s-manfmonth-val-kpi-9', this.manfMonthFilterKpi8.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-9');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi8 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-9');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi8= monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi8 == null) {
      this.manfMonthFilterKpi8 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi8 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi8 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi8 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpStoreKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyMATD: number = 0;
    let _delayQtyMATD: number = 0;
    let _onTimeQtyMATD: number = 0;
    let _delayQtyMATDZS1: number = 0;
    let _onTimeQtyMATDZS1: number = 0;
    let _delayQtyMATDZS1DBB: number = 0;
    let _onTimeQtyMATDZS1DBB: number = 0;
    let _delayQtyMATDZS2: number = 0;
    let _onTimeQtyMATDZS2: number = 0;
    let _delayQtyMATDZS9: number = 0;
    let _onTimeQtyMATDZS9: number = 0;
    let _delayQtyMATDZN1: number = 0;
    let _onTimeQtyMATDZN1: number = 0;

    let _totalQtyMATL: number = 0;
    let _delayQtyMATL: number = 0;
    let _onTimeQtyMATL: number = 0;
    let _delayQtyMATLZS1: number = 0;
    let _onTimeQtyMATLZS1: number = 0;
    let _delayQtyMATLZS1DBB: number = 0;
    let _onTimeQtyMATLZS1DBB: number = 0;
    let _delayQtyMATLZS2: number = 0;
    let _onTimeQtyMATLZS2: number = 0;
    let _delayQtyMATLZS9: number = 0;
    let _onTimeQtyMATLZS9: number = 0;
    let _delayQtyMATLZN1: number = 0;
    let _onTimeQtyMATLZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi8.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi8[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for Material issue to dispatch planned and Actual Dates      

            if (_tmpSSO.storeIP.looseMaterialIssueToDispatchActualDate != null) {
              let _matdActual = _tmpSSO.storeIP.looseMaterialIssueToDispatchActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _matdOtherDate;
              if( _tmpSSO.storeIP.looseMaterialIssueToDispatchRequestDate==null){
                _isRequested = false;
                _matdOtherDate = _tmpSSO.storeIP.looseMaterialIssueToDispatchPlannedDate.getTime();
                _isRevised = _tmpSSO.storeIP.looseMaterialIssueToDispatchPlannedDateIsRevised;
            }
            else{
              _isRequested = true;
              _matdOtherDate = _tmpSSO.storeIP.looseMaterialIssueToDispatchRequestDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyMATD += temp;
                  
                  
                }
              }
            });
              let _matdDiff_time =  _matdOtherDate - _matdActual;
              let _matdDiff = _matdDiff_time / (1000 * 3600 * 24);
              ///Material issue to dispatch Finalization Delay
              if (_matdDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyMATD += temp;
                    }
                  }
                });

                let _individualDelayQtyMat = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATDZS1 += temp;
                          _individualDelayQtyMat += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATDZS1DBB += temp;
                          _individualDelayQtyMat += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATDZS2 += temp;
                          _individualDelayQtyMat += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATDZN1 += temp;
                          _individualDelayQtyMat += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATDZS9 += temp;
                          _individualDelayQtyMat += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.storeIP.looseMaterialIssueToDispatchPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.storeIP.looseMaterialIssueToDispatchPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.storeIP.looseMaterialIssueToDispatchRequestDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Material issue to dispatch', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyMat, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.storeIP.looseMaterialIssueToDispatchActualDate, _matdDiff, _tmpSSO.storeIP.looseMaterialIssueToDispatchActualToken.addNotes)
               
                _tmpStoreKpi.push(_tmpSSOobj);
              }
              // Material issue to dispatch Finalization on Time
              if (_matdDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyMATD += temp;
                    }
                  }
                });

                let _individualOnTimeQtyMat = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATDZS1 += temp;
                          _individualOnTimeQtyMat += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATDZS1DBB += temp;
                          _individualOnTimeQtyMat += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATDZS2 += temp;
                          _individualOnTimeQtyMat += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATDZN1 += temp;
                          _individualOnTimeQtyMat += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATDZS9 += temp;
                          _individualOnTimeQtyMat += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.storeIP.looseMaterialIssueToDispatchPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.storeIP.looseMaterialIssueToDispatchPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.storeIP.looseMaterialIssueToDispatchRequestDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Material issue to dispatch', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyMat, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.storeIP.looseMaterialIssueToDispatchActualDate, _matdDiff, _tmpSSO.storeIP.looseMaterialIssueToDispatchActualToken.addNotes)

                _tmpStoreKpi.push(_tmpSSOobj);
              }     


            }

            // Check for Material issue to line Planned and Actual Dates

            if (_tmpSSO.storeIP.materialIssueToLineActualDate != null) {
              let _matlActual = _tmpSSO.storeIP.materialIssueToLineActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _matlOtherDate;
              if( _tmpSSO.storeIP.materialIssueToLineRequestLineLodingDate==null){
                _isRequested = false;
                _matlOtherDate = _tmpSSO.storeIP.materialIssueToLinePlannedDate.getTime();
                _isRevised = _tmpSSO.storeIP.materialIssueToLinePlannedDateIsRevised;
            }
            else{
              _isRequested = true;
              _matlOtherDate = _tmpSSO.storeIP.materialIssueToLineRequestLineLodingDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyMATL += temp;
                }
              }
            });
              let _matlDiff_time =  _matlOtherDate - _matlActual;
              let _matlDiff = _matlDiff_time / (1000 * 3600 * 24);
              ///Material issue to line Finalization Delay
              if (_matlDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyMATL += temp;
                    }
                  }
                });

                let _individualDelayQtyMatLine = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATLZS1 += temp;
                          _individualDelayQtyMatLine += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATLZS1DBB += temp;
                          _individualDelayQtyMatLine += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATLZS2 += temp;
                          _individualDelayQtyMatLine += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATLZN1 += temp;
                          _individualDelayQtyMatLine += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMATLZS9 += temp;
                          _individualDelayQtyMatLine += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.storeIP.materialIssueToLinePlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.storeIP.materialIssueToLinePlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.storeIP.materialIssueToLineRequestLineLodingDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Material issue to line',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyMatLine, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.storeIP.materialIssueToLineActualDate, _matlDiff, _tmpSSO.storeIP.materialIssueToLineActualToken.addNotes)
               
                  _tmpStoreKpi.push(_tmpSSOobj);
              }
              //Material issue to line on Time
              if (_matlDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyMATL += temp;
                    }
                  }
                });

                let _individualOnTimeQtyMatLine = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATLZS1 += temp;
                          _individualOnTimeQtyMatLine += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATLZS1DBB += temp;
                          _individualOnTimeQtyMatLine += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATLZS2 += temp;
                          _individualOnTimeQtyMatLine += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATLZN1 += temp;
                          _individualOnTimeQtyMatLine += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMATLZS9 += temp;
                          _individualOnTimeQtyMatLine += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.storeIP.materialIssueToLinePlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.storeIP.materialIssueToLinePlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.storeIP.materialIssueToLineRequestLineLodingDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Material issue to line',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyMatLine, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.storeIP.materialIssueToLineActualDate, _matlDiff, _tmpSSO.storeIP.materialIssueToLineActualToken.addNotes)
               
                    _tmpStoreKpi.push(_tmpSSOobj);
              }     


            }

          });

        }


      }

    }

    if (_totalQtyMATD != 0 || _onTimeQtyMATD != 0 || _delayQtyMATD != 0) {
      this.totalDataMATD = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyMATD,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyMATD,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyMATD,
        }]
      }

      ];
    }
    else { this.totalDataMATD = null; }

    this.totalDataKpiChartOptionsMATD = this._kpiCharServ.getTotalDataChartOptions(this.totalDataMATD);

    if (_onTimeQtyMATDZN1 != 0 || _onTimeQtyMATDZS9 != 0 || _onTimeQtyMATDZS1 != 0 || _onTimeQtyMATDZS1DBB != 0 || _onTimeQtyMATDZS2 != 0
      || _delayQtyMATDZN1 != 0 || _delayQtyMATDZS9 != 0 || _delayQtyMATDZS1 != 0 || _delayQtyMATDZS1DBB != 0 || _delayQtyMATDZS2 != 0) {

      this.panelWiseDataMATD = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyMATDZN1, _onTimeQtyMATDZS9, _onTimeQtyMATDZS1, _onTimeQtyMATDZS1DBB, _onTimeQtyMATDZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyMATDZN1, _delayQtyMATDZS9, _delayQtyMATDZS1, _delayQtyMATDZS1DBB, _delayQtyMATDZS2],
      }

      ];
    }
    else { this.panelWiseDataMATD = null; }

    this.panelWiseKpiChartOptionsMATD = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataMATD);


    ////

    if (_totalQtyMATL != 0 || _onTimeQtyMATL != 0 || _delayQtyMATL != 0) {
      this.totalDataMATL = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyMATL,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyMATL,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyMATL,
        }]
      }

      ];
    }
    else { this.totalDataMATL = null; }

    this.totalDataKpiChartOptionsMATL = this._kpiCharServ.getTotalDataChartOptions(this.totalDataMATL);

    if (_onTimeQtyMATLZN1 != 0 || _onTimeQtyMATLZS9 != 0 || _onTimeQtyMATLZS1 != 0 || _onTimeQtyMATLZS1DBB != 0 || _onTimeQtyMATLZS2 != 0
      || _delayQtyMATLZN1 != 0 || _delayQtyMATLZS9 != 0 || _delayQtyMATLZS1 != 0 || _delayQtyMATLZS1DBB != 0 || _delayQtyMATLZS2 != 0) {

      this.panelWiseDataMATL = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyMATLZN1, _onTimeQtyMATLZS9, _onTimeQtyMATLZS1, _onTimeQtyMATLZS1DBB, _onTimeQtyMATLZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyMATLZN1, _delayQtyMATLZS9, _delayQtyMATLZS1, _delayQtyMATLZS1DBB, _delayQtyMATLZS2],
      }

      ];
    }
    else { this.panelWiseDataMATL = null; }

    this.panelWiseKpiChartOptionsMATL = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataMATL);



    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.StoreKpi = _tmpStoreKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi8 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi8) {
      return this.manfMonthFilterKpi8.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi8) {
      return this.manfMonthFilterKpi8.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi8.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi8.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi8.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi8.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi8 == true && this.manfMonthFilterKpi8 != null) {
      if (this.manfMonthFilterKpi8.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}
